import { useNavigate } from '@fukuri-admins/hooks/common';
import { useToast } from '@fukuri-admins/ui/common/Toast/hooks';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetStressAssessmentSchedule } from '~/usecases/useGetStressAssessmentSchedule';
import { ROUTES } from '~/utils/routes';
import { deleteStressAssessmentSchedule } from './useDeleteStressAssessmentSchedule';

export const useStressAssessmentScheduleAlert = () => {
  const navigate = useNavigate();
  const threeLetterCode = getThreeLetterCode();
  const { data, mutate } = useGetStressAssessmentSchedule({ threeLetterCode });
  const targetMonths = data?.stress_check_schedule?.target_months ?? [];
  const isScheduleSet = targetMonths.length > 0;
  const { showToast } = useToast();

  const onClickReset = async () => {
    try {
      await deleteStressAssessmentSchedule(threeLetterCode);
      mutate();
    } catch {
      showToast({ message: 'リセットに失敗しました。', status: 'danger' });
    }
  };

  return {
    isScheduleSet,
    onClickSetSchedule: () => navigate(ROUTES.STRESS_ASSESSMENTS.SCHEDULE),
    onClickEdit: () => navigate(ROUTES.STRESS_ASSESSMENTS.SCHEDULE),
    onClickReset,
  };
};
